import CryptoCloudIcon from '../../assets/images/payment-types/crypto-cloud-icon.webp'
import UsdtIcon from '../../assets/images/payment-types/usdt-icon.webp'
import CashIcon from '../../assets/images/payment-types/cash-icon.webp'


export const PAYMENT_ICONS = [
    {
        img: CryptoCloudIcon,
        title: 'Crypto Cloud',
    },
    {
        img: UsdtIcon,
        title: 'USDT',
    },
    {
        img: CashIcon,
        title: 'Cash on Delivery',
    },
]